<script>
  import AboutHead from "../md_components/AboutHead.md"
  import AboutBooks from "../md_components/AboutBooks.md"
  import AboutPlay from "../md_components/AboutPlay.md"
  import AboutQi from "../md_components/AboutQi.md"
  import AboutRecords from "../md_components/AboutRecords.md"
  import AboutMe from "../md_components/AboutMe.md"
  import AboutFee from "../md_components/AboutFee.md"
  import AboutFAQ from "../md_components/AboutFAQ.md"
  import { selectedLanguage } from "../etc/store.js"

  let showIntro = true
  let abtBook = false
  let abtPlay = false
  let abtQi = false
  let abtRecord = false
  let abtMe = false
  let abtFee = false
  let abtFaq = false
  let btn_style = "btn waves-effect waves-light light-blue darken-1 btn-single"

  function showAboutDescription(id) {
    // This is for reset for any button click or Close All button
    abtBook = false
    abtPlay = false
    abtQi = false
    abtRecord = false
    abtMe = false
    abtFee = false
    abtFaq = false
    showIntro = true
    // Other button showing...
    if (id == "abt-book") {
      abtBook = !abtBook
      showIntro = false
    }
    if (id == "abt-play") {
      abtPlay = !abtPlay
      showIntro = false
    }
    if (id == "abt-qi") {
      abtQi = !abtQi
      showIntro = false
    }
    if (id == "abt-record") {
      abtRecord = !abtRecord
      showIntro = false
    }
    if (id == "abt-me") {
      abtMe = !abtMe
      showIntro = false
    }
    if (id == "abt-fee") {
      abtFee = !abtFee
      showIntro = false
    }
    if (id == "abt-faq") {
      abtFaq = !abtFaq
      showIntro = false
    }
    if (id == "abt-all") {
      abtBook = true
      abtPlay = true
      abtQi = true
      abtRecord = true
      abtMe = true
      abtFee = true
      abtFaq = true
      showIntro = false
    }
  }
</script>

<main>
  <div class="about">
    <h3>
      {$selectedLanguage == "TW"
        ? "關於 【XiYi 習易網】"
        : "关于 【XiYi 习易网】"}
    </h3>
    <h6>
      {$selectedLanguage == "TW"
        ? "核心價值：省時、省力、隨時、隨地。不再需要韋編三絕。"
        : "核心价值：省时、省力、随时、随地。不再需要韦编三绝。"}
    </h6>

    <hr />
    <div class="intro" style="display: {showIntro ? 'block' : 'none'}">
      <AboutHead />
    </div>
  </div>

  <div>
    <h5>以下是【XiYi 習易網】更詳細的介紹：</h5>
    <hr />
    <div class="btn-row">
      <button
        class={btn_style}
        on:click={() => showAboutDescription("abt-book")}
      >
        古籍
      </button>
      <button
        class={btn_style}
        on:click={() => showAboutDescription("abt-play")}
      >
        玩卦
      </button>
      <button class={btn_style} on:click={() => showAboutDescription("abt-qi")}>
        起卦
      </button>
      <button
        class={btn_style}
        on:click={() => showAboutDescription("abt-record")}
      >
        卦例
      </button>
      <button class={btn_style} on:click={() => showAboutDescription("abt-me")}>
        作者
      </button>
      <button
        class={btn_style}
        on:click={() => showAboutDescription("abt-fee")}
      >
        費用
      </button>
      <button
        class={btn_style}
        on:click={() => showAboutDescription("abt-faq")}
      >
        FAQ
      </button>
      <button
        class="btn waves-effect waves-light teal darken-1 btn-single"
        on:click={() => showAboutDescription("abt-all")}
      >
        全展
      </button>
      <button
        class="btn waves-effect waves-light yellow darken-3 btn-single"
        on:click={() => showAboutDescription("abt-close")}
      >
        全關
      </button>
    </div>
  </div>

  <div class="card indigo lighten-5">
    <div
      id="abt-book"
      class="card-body about-description"
      style="display:{abtBook ? 'block' : 'none'}"
    >
      <AboutBooks />
    </div>
  </div>
  <div class="card indigo lighten-5">
    <div
      id="abt-play"
      class="card-body about-description"
      style="display:{abtPlay ? 'block' : 'none'}"
    >
      <AboutPlay />
    </div>
  </div>

  <div class="card indigo lighten-5">
    <div
      id="abt-qi"
      class="card-body about-description"
      style="display:{abtQi ? 'block' : 'none'}"
    >
      <AboutQi />
    </div>
  </div>

  <div class="card indigo lighten-5">
    <div
      id="abt-record"
      class="card-body about-description"
      style="display:{abtRecord ? 'block' : 'none'}"
    >
      <AboutRecords />
    </div>
  </div>
  <div class="card indigo lighten-5">
    <div
      id="abt-me"
      class="card-body about-description"
      style="display:{abtMe ? 'block' : 'none'}"
    >
      <AboutMe />
    </div>
  </div>

  <div class="card indigo lighten-5">
    <div
      id="abt-fee"
      class="card-body about-description"
      style="display:{abtFee ? 'block' : 'none'}"
    >
      <AboutFee />
    </div>
  </div>
  <div class="card indigo lighten-5">
    <div
      id="abt-faq"
      class="card-body about-description"
      style="display:{abtFaq ? 'block' : 'none'}"
    >
      <AboutFAQ />
    </div>
  </div>
</main>

<style>
  .btn-single {
    /* width: auto; */
    min-width: 65px;
    height: 40px;
    margin-top: 10px;
    margin-right: 10px;
  }
  .about-description {
    margin: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .yao-stat {
    width: 100%;
  }
  ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }

  li {
    font-size: 16px;
  }
  p {
    font-size: 16px;
  }
</style>
